import React from "react";
import { RouteComponentProps } from "@reach/router";

const Home: React.FC<RouteComponentProps> = () => {
  return <div />
};

export default Home;
